import React from 'react';
import PropTypes from 'prop-types';
import './EllipsisLoader.css';

export const EllipsisLoader = (props) => {
  const { text, noBackground } = props;
  const loaderClass = noBackground ? 'loader-div loader-div-no-background' : 'loader-div';

  return (
    <div className={loaderClass}>
      <div className="loader-text">{text}</div>
      <div className="lds-css ng-scope">
        <div className="lds-ellipsis">
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
        </div>
      </div>
    </div>
  );
};

EllipsisLoader.propTypes = {
  text: PropTypes.string.isRequired,
  noBackground: PropTypes.bool,
};

EllipsisLoader.defaultProps = {
  noBackground: false,
};
